// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClassicHeader_wrapper__v0mdu","rowGap":"ClassicHeader_rowGap__udNRU"};